import { render, staticRenderFns } from "./TextShow.vue?vue&type=template&id=f6a8db78&scoped=true&"
import script from "./TextShow.vue?vue&type=script&scoped=true&lang=js&"
export * from "./TextShow.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./TextShow.vue?vue&type=style&index=0&id=f6a8db78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a8db78",
  null
  
)

export default component.exports